import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import { Fancybox } from '@fancyapps/ui';
import GalleryPage from './gallery';
import Extend from 'flarum/common/extenders';
import Link from 'flarum/common/components/Link';
import Discussion from 'flarum/common/models/Discussion';


export default [
  new Extend.Routes()
    .add('rz-pazirik.gallery', '/g/:id', <GalleryPage />),
];

//init
var limit = 15;
var gallery;
//var discussionPosts;
var aArray = new Array();

app.initializers.add('rz-pazirik/flarum-discussion-gallery', function(app) {

    //define topic gallery route with id parameter
    app.routes.g = {path: '/g/:id', component: GalleryPage };

    //DiscussionPage - oncreate
    /*
    extend(DiscussionPage.prototype, 'oncreate', function() {
    });
    */

    //DiscussionPage - onupdate
    extend(DiscussionPage.prototype, 'onupdate', function() {

        console.log('update');
        let page = $(this.element);

        //RENDER
        if (page.find('.topic-gallery').length === 0) {
            if (typeof document.querySelector('.item-gallery') !== undefined) {
                let target = document.querySelector('.item-gallery');
                if (typeof target !== 'undefined' && typeof gallery !== 'undefined') {
                    if (gallery != null && target != null) {
                        m.render(target, gallery);
                        //console.log('RENDER');
                    }
                }
            }
        }

        bindFancybox();

    });


    //DiscussionPage - oninit
    extend(DiscussionPage.prototype, 'oninit', function() {
        //INIT
        console.log('init');
        gallery = null;
        aArray = [];

        //send get request for images
        imageXHR(this.attrs.id, limit);
    });


    //DiscussionPage - oncreate
    extend(DiscussionPage.prototype, 'oncreate', function() {
        console.log('oncreate');
    });

    //extend DiscussionPage sidebarItems with Image Gallery from the selected topic
    extend(DiscussionPage.prototype, 'sidebarItems', function(items) {

        //add 'item-gallery' item to sidebar if not exists
        if (!items.has('gallery')) {
            items.add('gallery', <p></p>, -200);
        }

    });


    //DiscussionPage - onupdate
    extend(GalleryPage.prototype, 'onupdate', function() {
        bindFancybox();
    });

    //DiscussionPage - load
    extend(DiscussionPage.prototype, 'load', function() {
        console.log('load');
    });

    //Discussion Model - save
    extend(Discussion.prototype, 'save', function() {
        console.log('save');
    });

});



//generate gallery html
function imageGallery(imageArray, slug) {

    var mArray = new Array();
    var href = '/g/' + slug;

    imageArray.forEach(element => {
        mArray.push(
            //m("li", {}, [
                m("a", { href: element, 'data-fancybox': 'topic-gallery' }, 
                 [
                    m("img", { src: element })
                ])
            //])
        );
    });



    return m("div", { class: "topic-gallery" }, [
        m("h5", {}, 'Képgaléria'),
        m("div", { class: "topic-gallery-images" }, mArray),
        m("a", <Link href={href} className="gallery-link">Képgaléria oldal</Link>)
    ]);

}


//get request
function imageXHR(id, limit) {
    m.request({
        method: "GET",
        url: "https://m500.pazirikkft.hu/teszt.php",
        async: true,
        withCredentials: true,
        responseType: "json",
        params: {id: id, limit: limit}
    })
    .then(function(result) {
        gallery = imageGallery(result.data, id);
    })
}



function bindFancybox() {

    //BIND
    if ($('.topic-gallery-images a').length > 0 && aArray.length == 0) {

        aArray = $('.topic-gallery-images a');
        //console.log('BIND');

        $(aArray).each(function(index, element) {

            //bind click event to gallery items
            $(element).on('click', function(e) {

                e.preventDefault();

                //find index to start fancybox gallery with the clicked image
                const group = $(`a[data-fancybox="topic-gallery"]`).toArray();
                const startIndex = group.indexOf(element);

                //set onclick to show Fancybox group
                Fancybox.fromNodes(aArray, {
                    Carousel: {
                        infinite: false,
                        preload: 0,
                    },
                    Toolbar: {
                        display: {
                        left: ['infobar'],
                        middle: ['rotateCCW', 'rotateCW', 'flipX', 'flipY'],
                        right: ['slideshow', 'fullscreen', 'close'],
                        },
                    },
                    dragToClose: true,
                    Hash: false,
                    startIndex
                    });
            }).addClass('fancybox-ready');
    
        });
    }

}